import { useQueryClient } from "@tanstack/react-query";
import { Modal } from "components";
import { Button } from "expano-components";
import useCreate from "hooks/useCreate";

const CreateProductGroupsFromCsvModal = ({
  data,
  attributes,
  is_file_correct,
  handleClose,
}) => {
  const query = useQueryClient();

  const { is_creating, create } = useCreate({
    path: "/product_groups/bulk_import",
    onSuccess: () => {
      query.refetchQueries(["product_groups"]);
      handleClose();
    },
  });
  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: "Dodaj produkty grupowe",
      }}
      size="xl"
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={is_creating || !is_file_correct}
            onClick={() => create({ product_groups_attributes: attributes })}
          />
        </>
      }
    >
      <table className="table">
        <thead className="table__header table-head">
          <tr>
            <th>SKU</th>
            <th>Nazwa</th>
            <th>Kategoria</th>
            <th>Producent</th>
            <th>Marka</th>
            <th>Kod CN</th>
            <th>Kraj pochodzenia</th>
          </tr>
        </thead>
        <tbody className="table__body table-body">
          {data.map(
            ({
              sku,
              name,
              brand,
              producer,
              root_taxon,
              cn_code,
              country_of_origin,
            }) => (
              <tr key={sku}>
                <td>{sku || <span className="text-danger">Brak sku</span>}</td>
                <td>
                  {name || <span className="text-danger">Brak nazwy</span>}
                </td>
                <td>
                  {root_taxon?.id ? (
                    <span>
                      [{root_taxon.identifier}] {root_taxon.name}
                    </span>
                  ) : (
                    <span className="text-danger">Brak kategorii</span>
                  )}
                </td>
                <td>
                  {producer?.name || (
                    <span className="text-danger">Brak producenta</span>
                  )}
                </td>
                <td>
                  {brand?.name || (
                    <span className="text-danger">Brak marki</span>
                  )}
                </td>
                <td>
                  {cn_code || (
                    <span className="text-danger">Brak kodu CN</span>
                  )}
                </td>
                <td>
                  {country_of_origin || (
                    <span className="text-danger">Brak kraju</span>
                  )}
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </Modal>
  );
};

export default CreateProductGroupsFromCsvModal;
